export const vehicle = state => state.vehicle
export const vehicles = state => state.vehicles
export const models = state => state.models
export const carEstimates = state => state.carEstimates
